'use strict'

const _ = require('lodash')

const TPA_WIDGET_DATA_TYPE = 'TPAWidget'
const TPA_GLOBAL_DATA = 'TPAGlobalData'
const TPA_MULTI_SECTION_DATA_TYPE = 'TPAMultiSection'
const TPA_SECTION_DATA_TYPE = 'TPA'

const isTPAWidget = dataType => dataType === TPA_WIDGET_DATA_TYPE
const isTPAGlobalData = dataType => dataType === TPA_GLOBAL_DATA
const isTPASection = dataType => dataType === TPA_SECTION_DATA_TYPE
const isTPAMultiSection = dataType => dataType === TPA_MULTI_SECTION_DATA_TYPE

const getAllTPAWidgetsDataItems = pageJson => {
    const dataItems = _.get(pageJson, 'data.document_data')
    return _.filter(dataItems, ({type}) => isTPAWidget(type) || isTPAGlobalData(type) || isTPASection(type) || isTPAMultiSection(type))
}

const completeDataItemWithAppDefinitionId = (componentData, clientSpecMap) => {
    const applicationId = isTPAGlobalData(componentData.type) ? componentData.id.split('-')[1] : componentData.applicationId
    const appDefinitionId = _.get(clientSpecMap, [applicationId, 'appDefinitionId'])

    _.set(componentData, 'appDefinitionId', appDefinitionId)
}

const completeSectionDataItemWithWidgetId = (componentData, clientSpecMap) => {
    const appWidgets = _.get(clientSpecMap, [componentData.applicationId, 'widgets'])
    const mainSectionWidget = _.find(appWidgets, widget => widget.appPage && widget.appPage.name && !widget.appPage.hidden)
    const widgetId = _.get(mainSectionWidget, 'widgetId')
    _.set(componentData, 'widgetId', widgetId)
}

module.exports = {
    /*
     * Add appDefinitionId property to each TPA component data item
     * Add widgetId property to TPA Section data items
     */
    exec(pageJson, pageIdsArray, requestModel, currentUrl, urlFormatModel, isViewerMode, rendererModel, {clientSpecMap}) {
        const tpaWidgetsDataItems = getAllTPAWidgetsDataItems(pageJson)

        _.forEach(tpaWidgetsDataItems, dataItem => {
            completeDataItemWithAppDefinitionId(dataItem, clientSpecMap)

            if (isTPASection(dataItem.type) && !_.get(dataItem, 'widgetId')) {
                completeSectionDataItemWithWidgetId(dataItem, clientSpecMap)
            }
        })
    }
}
